<template>
  <div>

    <md-dialog :md-active.sync="showDialog">
      <div>         
        <md-button class="md-icon-button icon1" @click="showDialog = false">
          <md-icon >cancel</md-icon>
        </md-button> 
        <br/>
        <md-dialog-title>BOL Photos</md-dialog-title>
        <br/>
       </div>

      <md-dialog-content>
        <div class="ccic-photos-container">
          <div :key="getPhotoWrapperKey(w)" v-for="w in getPhotoWrapperList">
            <ccic-photo :photo="w.photo" :photoMeta="w.meta" :savePhotoButton = savePhotoButton :do-photo-upload="doPhotoUpload" />
          </div>
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>

</template>
<style scoped>
  .ccic-photos-container {
    min-width: 800px;
  }

  .md-dialog-content {
    padding: 8px;
  }

  .icon1{
    /* cursor: pointer; */
    float: right;
    margin: 5px;
  }
  
</style>
<script>
  import { mapGetters } from 'vuex';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import CcicPhoto from "./CcicPhoto.vue";

  export default {
    props: {
      onDataRefresh: Function,
    },
    components: { CcicPhoto },
    data: () => ({
      showDialog: false,
      photoZipFileName: '',
      parentSeqNo: '',
      parentType: '',
      stageNo: '',
      photos: [],
      hasPhotoChanged: false,
      photoMeta: [],
      getPhotoRequest: null,
      urlToSave:null,
      savePhotoButton: false,
    }),
    computed: {
      ...mapGetters([
        'getUserProfile',
      ]),
      getPhotoWrapperList() {
        return this.photoMeta.map(meta => {
          const photo = this.getPhotoForKey(meta.key);
          
          if (photo) {
            console.log("photo photoUrl--: " + photo.photoUrl);
            photo.photoUrl = `${photo.photoUrl}?t=${moment(photo.updatedAt)
              .unix()}`;
            console.log("photo photoUrl: " + photo.photoUrl);
          }
          return {
            meta,
            photo,
          };
        });
      },
    },
    watch: {
      showDialog(val) {
        if (val === false) {
          console.log(`1`);
          if (this.hasPhotoChanged) {
            this.onDataRefresh(this.urlToSave, this.parentSeqNo);
          }
          console.log(`2`);
          this.photoMeta = [];
          this.photos = [];
          this.hasPhotoChanged = false;
          this.savePhotoButton = false;
          this.$store.commit('clearApiError');
        }
      },
    },
    methods: {
      async openDialog(photoZipFileName, parentSeqNo, parentType, photoMeta, getPhotoRequest, savePhotoButton) {
        this.savePhotoButton = savePhotoButton;
        this.photoZipFileName = photoZipFileName;
        this.parentSeqNo = parentSeqNo;
        this.parentType = parentType;
        this.photoMeta = photoMeta;
        this.showDialog = true;
        this.getPhotoRequest = getPhotoRequest;
        this.hasPhotoChanged = true;
        this.urlToSave = null;
        
        this.photos = await this.getPhoto();
        if (this.photos.photo.length != 0)
        {
            this.urlToSave = this.photos.photo[0].photoUrl;
        }
        
        console.log("photoMeta: " + this.photoMeta[0].fileName);
        console.log("photoMeta: " + this.photoMeta[1].fileName);
        console.log(this.urlToSave);


        
      },
      getPhotoForKey(key) {
        console.log("key: " + key);
        return _(this.photos.photo)
          .find(it => it.photoKey === key);
      },
      async doPhotoUpload(request) {
        request.parentSeqNo = this.parentSeqNo;
        request.parentType = this.parentType;
        request.image.folder = `INBOUND/${this.parentSeqNo}`;
        //await api.post('/api/w/ccic/photo/save', request);
        await newAPIPost('/api/w/ccic/photo/save', request);
        this.photos = await this.getPhoto();
        if (this.photos.photo.length != 0)
        {
            this.urlToSave = this.photos.photo[0].photoUrl;
        }

        console.log(this.urlToSave);
        
        
      },
      getPhotoWrapperKey(w) {
        if (w.photo) {
          return `${w.meta.key}-${moment(w.photo.updatedAt)
            .format()}`;
        }
        return w.meta.key;
      },
     getPhoto() {
        //return  api.post('/api/w/gst/photo/get', this.getPhotoRequest)
        return  newAPIPost('/api/w/gst/photo/get', this.getPhotoRequest)
        
      },
    },
  };


</script>
